<template lang="html">
  <font-awesome-icon :icon="['fas', 'chevron-left']" class="wcc auth-back" title="Back" v-hammer:tap="back"/>
</template>
<script>
  export default {
    methods: {
      back() {
        this.$store.dispatch('auth/clear')
        this.$store.dispatch('auth/chooseBack')
      }
    }
  }
</script>
<style lang="scss">
  .wcc.auth-back {
    position: absolute;
    color: $grey-400;
    height: .8em;
    width: auto;
    top: .2em;
    left: 0;
    transition-duration: $transition-duration;
    cursor: pointer;
    @media (hover: hover) {
      &:hover {
        color: $red;
      }
    }
    &:focus {
      color: $red;
    }
  }
</style>